export const ORDERS_REPORT_VENUE_CONFIRM_COUNT = 40

export const shouldConfirmOrdersReportSize = count =>
  Number(count) > ORDERS_REPORT_VENUE_CONFIRM_COUNT

export const ordersReportLargeGroupQuestion = count =>
  `This orders report has ${count} venues. Generate it now?`

export const shouldCloseOrdersReportAfterDownload = () => false

export const ORDERS_REPORT_EMPTY_TITLE = 'No orders in this period'
export const ORDERS_REPORT_EMPTY_SECTION =
  'Venues with no orders in this period'

export const ordersReportRowsWithEmptyVenues = (rows, selectedVenues) => {
  const present = new Set((rows || []).map(row => row?.Venue).filter(Boolean))
  const missing = (selectedVenues || []).filter(venue => {
    const title = venue?.title || ''
    return title && !present.has(title)
  })
  if (missing.length === 0) return [...(rows || [])]
  const section = {
    PO: '',
    Title: ORDERS_REPORT_EMPTY_SECTION,
    sku: '',
    Quantity: '',
    OrderDate: '',
    ItemPrice: '',
    TotalPrice: '',
    Venue: '',
    Buyer: '',
    Supplier: '',
    Status: '',
  }
  const extra = missing.map(venue => ({
    PO: '',
    Title: ORDERS_REPORT_EMPTY_TITLE,
    sku: '',
    Quantity: '',
    OrderDate: '',
    ItemPrice: '',
    TotalPrice: '',
    Venue: venue.title,
    Buyer: '',
    Supplier: '',
    Status: ORDERS_REPORT_EMPTY_TITLE,
  }))
  return [section, ...extra, ...(rows || [])]
}
